import { useNavigate } from 'react-router-dom'

import { BankingIntroPage } from '@/features/banking/BankingIntroPage'
import { BankingApplicationStage } from '@/features/onboarding/banking-application'
import { ConnectStage } from '@/features/onboarding/connect-stage'
import { CONNECT_BANK_PATHS } from '@/features/banking/banking.constants'

const DASHBOARD_PATH = '/dashboard'
const BANKING_INTRO_PATH = '/banking/intro'
const BANKING_APPLY_PATH = '/banking/apply'

/**
 * Direct-route entry for the Heard Banking intro page (linked from the dashboard
 * `APPLY_HEARD_BANKING` onboarding item). Back/Skip return to the dashboard;
 * Continue advances to the application form.
 */
export const BankingIntroDashboardRoute = () => {
  const navigate = useNavigate()
  return (
    <BankingIntroPage
      onBack={() => navigate(DASHBOARD_PATH)}
      onContinue={() => navigate(BANKING_APPLY_PATH)}
      onSkip={() => navigate(DASHBOARD_PATH)}
    />
  )
}

/**
 * Direct-route entry for the Heard Banking application form. Back returns to
 * the intro page; Skip and post-submit Continue both return to the dashboard.
 */
export const BankingApplicationDashboardRoute = () => {
  const navigate = useNavigate()
  return (
    <BankingApplicationStage
      onBack={() => navigate(BANKING_INTRO_PATH)}
      onContinue={() => navigate(DASHBOARD_PATH)}
      onSkip={() => navigate(DASHBOARD_PATH)}
    />
  )
}

/**
 * Direct-route entry for the connect-bank step (linked from the dashboard
 * `CONNECT_HEARD_BANK` onboarding item). Back returns to the dashboard.
 */
export const ConnectDashboardRoute = () => {
  const navigate = useNavigate()
  return <ConnectStage onBack={() => navigate(DASHBOARD_PATH)} />
}

export const BANKING_DASHBOARD_ROUTES = {
  intro: BANKING_INTRO_PATH,
  apply: BANKING_APPLY_PATH,
  connect: CONNECT_BANK_PATHS.dashboard,
} as const
